const userQuotesApi = require('../api/userQuotes');

const MIN_USER_QUOTES_UPDATE = 1000 * 60 * 30; // 5 minutes
const FETCH_USER_QUOTES_TIMEOUT = 1000 * 30; // 30 seconds

function fetchUserQuotesInProgress() {
  return {
    type: 'FETCH_USER_QUOTES_IN_PROGRESS',
    timestamp: Date.now(),
  };
}

function fetchUserQuotesSuccessful(data) {
  return {
    type: 'FETCH_USER_QUOTES_SUCCESSFUL',
    data,
    timestamp: Date.now(),
  };
}

function fetchUserQuotesFailed(reason) {
  return {
    type: 'FETCH_USER_QUOTES_FAILED',
    reason,
    timestamp: Date.now(),
  };
}

function fetchUserQuotes() {
  return (dispatch, getState) => {
    dispatch(fetchUserQuotesInProgress());

    const state = getState();
    const { apiUrl } = state.auth;

    if (!apiUrl) {
      return Promise.resolve();
    }

    return userQuotesApi.fetchUserQuotes(apiUrl).then(
      (userQuotes) => {
        dispatch(fetchUserQuotesSuccessful(userQuotes));
        return userQuotes;
      },
      (error) => {
        dispatch(fetchUserQuotesFailed(error));
        throw error;
      },
    );
  };
}

function shouldFetchUserQuotes(state, skipOutdatedCheck) {
  const { fetchingInProgressSince, didInvalidate, lastSuccessfulFetch } =
    state.userQuotes;

  if (!fetchingInProgressSince) {
    // Should update if it was explicetely invalidated
    if (didInvalidate) {
      return true;
    }

    // Should update if data is too old
    if (
      !skipOutdatedCheck &&
      (!lastSuccessfulFetch ||
        Date.now() - lastSuccessfulFetch > MIN_USER_QUOTES_UPDATE)
    ) {
      return true;
    }
  } else if (
    fetchingInProgressSince &&
    Date.now() - fetchingInProgressSince > FETCH_USER_QUOTES_TIMEOUT
  ) {
    // Ensure we cannot get stuck in fetchingInProgressSince=true state.
    return true;
  }

  return false;
}

function fetchUserQuotesIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchUserQuotes(getState())) {
      return dispatch(fetchUserQuotes());
    }
    return Promise.resolve();
  };
}

module.exports = {
  fetchUserQuotes,
  fetchUserQuotesIfNeeded,
};
